import { autorun } from 'mobx';
import { SpinnerStore } from './SpinnerStore';
import { AuthStore } from './AuthStore';
import { LotStore } from './LotStore';
import { UserStore } from './UserStore';
import { SingleLotStore } from './singleLotStore';
import { MessageStore } from './messageStore';
import { LocationStore } from './LocationStore';
import { ModalStore } from './ModalStore';
import { ThemeStore } from './ThemeStore';
import { SubscriptionStore } from './SubscriptionStore';
import { SingleSubscriptionStore } from './SingleSubscriptionStore';
import { AdminStore } from './AdminStore';
import { CharityBannerStore } from './CharityBannerStore';

const SPINNER_STORE = 'spinnerStore';
const AUTH_STORE = 'authStore';
const LOT_STORE = 'lotStore';
const USER_STORE = 'userStore';
const SINGLE_LOT_STORE = 'singleLotStore';
const MESSAGE_STORE = 'messageStore';
const LOCATION_STORE = 'locationStore';
const MODAL_STORE = 'modalStore';
const THEME_STORE = 'themeStore';
const SUBSCRIPTION_STORE = 'subscriptionStore';
const SINGLE_SUBSCRIPTION_STORE = 'singleSubscriptionStore';
const ADMIN_STORE = 'adminStore';
const CHARITY_BANNER_STORE = 'charityBannerStore';

export class RootStore {
  [SPINNER_STORE]: SpinnerStore;
  [AUTH_STORE]: AuthStore;
  [LOT_STORE]: LotStore;
  [USER_STORE]: UserStore;
  [SINGLE_LOT_STORE]: SingleLotStore;
  [MESSAGE_STORE]: MessageStore;
  [LOCATION_STORE]: LocationStore;
  [MODAL_STORE]: ModalStore;
  [THEME_STORE]: ThemeStore;
  [SUBSCRIPTION_STORE]: SubscriptionStore;
  [SINGLE_SUBSCRIPTION_STORE]: SingleSubscriptionStore;
  [ADMIN_STORE]: AdminStore;
  [CHARITY_BANNER_STORE]: CharityBannerStore;

  constructor() {
    Object.assign(this, {
      [SPINNER_STORE]: new SpinnerStore(this),
      [AUTH_STORE]: new AuthStore(this),
      [LOT_STORE]: new LotStore(this),
      [USER_STORE]: new UserStore(this),
      [SINGLE_LOT_STORE]: new SingleLotStore(this),
      [MESSAGE_STORE]: new MessageStore(this),
      [LOCATION_STORE]: new LocationStore(),
      [MODAL_STORE]: new ModalStore(this),
      [THEME_STORE]: new ThemeStore(this),
      [SUBSCRIPTION_STORE]: new SubscriptionStore(this),
      [SINGLE_SUBSCRIPTION_STORE]: new SingleSubscriptionStore(this),
      [ADMIN_STORE]: new AdminStore(),
      [CHARITY_BANNER_STORE]: new CharityBannerStore(),
    });

    this.autorunStores();
  }

  autorunStores() {
    autorun(() => {
      this[SINGLE_LOT_STORE].isLoading ? this[SPINNER_STORE].showSpinner() : this[SPINNER_STORE].hideSpinner();
    });
  }
}
